.header {
  position: relative;
  height: var(--header-h);
  background: var(--bg-dark);
  color: var(--text-on-dark);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 20px;
}

.hamburger {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: var(--legacy-warning);
  border-radius: var(--r-8);
  flex-shrink: 0;
  margin-left: auto;
}
.hamburger:hover {
  background: rgba(255, 255, 255, 0.06);
}

.mobilePanel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--bg-dark);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  padding: 8px;
  z-index: 30;
  max-height: calc(100vh - var(--header-h));
  overflow-y: auto;
}

.mobilePanelLink {
  padding: 12px 14px;
  border-radius: var(--r-8);
  color: var(--text-on-dark-muted);
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
}
.mobilePanelLink:hover {
  background: rgba(255, 255, 255, 0.06);
  color: var(--text-on-dark);
}

.mobilePanelDivider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 6px 4px;
}

.mobileGroup {
  display: flex;
  flex-direction: column;
}

.mobileGroupTrigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: transparent;
  border: none;
  font: inherit;
  cursor: pointer;
  text-align: left;
}

.chevronOpen {
  transform: rotate(180deg);
}

.mobileSubList {
  display: flex;
  flex-direction: column;
  padding-left: 14px;
}

.mobileSubLink {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  border-radius: var(--r-8);
  color: var(--text-on-dark-faint);
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
}
.mobileSubLink:hover {
  background: rgba(255, 255, 255, 0.06);
  color: var(--text-on-dark);
}

.profileTrigger {
  display: flex;
  align-items: center;
  gap: 8px;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--r-pill);
  object-fit: cover;
  flex-shrink: 0;
}

.badge {
  margin-left: auto;
  background: var(--danger);
  color: #fff;
  border-radius: var(--r-pill);
  font-size: 11px;
  font-weight: 700;
  padding: 2px 7px;
  line-height: 1.4;
}

.logo {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.nav {
  display: none;
  align-items: center;
  gap: 4px;
  flex-grow: 1;
}

.right {
  display: none;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

.navLink {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border-radius: var(--r-8);
  background: transparent;
  border: none;
  color: var(--text-on-dark-muted);
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}
.navLink:hover {
  color: var(--text-on-dark);
  background: rgba(255, 255, 255, 0.06);
}

.dropdown {
  position: relative;
}

.dropdownMenu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 200px;
  background: var(--bg-panel);
  color: var(--text-primary);
  border-radius: var(--r-8);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);
  padding: 6px;
  display: flex;
  flex-direction: column;
  z-index: 20;
}
.dropdownMenuRight {
  left: auto;
  right: 0;
}

.dropdownItem {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: var(--r-8);
  color: var(--text-primary);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.dropdownItem:hover {
  background: var(--bg-page);
}

.dropdownDivider {
  height: 1px;
  background: var(--border-2);
  margin: 6px 4px;
}

@media (min-width: 1200px) {
  .header {
    padding: 0 24px;
  }
  .nav,
  .right {
    display: flex;
  }
  .hamburger {
    display: none;
  }
}
